// extracted by mini-css-extract-plugin
export default {"container":"KeyActivities_container__zWexM"};